import request from '@/utils/request';
//优惠券列表
export function getUserGroupList(values) {
  return request('/profile/queryGroupPage', {
    method: 'POST',
    data: values,
  });
}
//获取活动相关信息
export function getActivityInfo(values) {
  return request('/activity/queryEventDetail', {
    method: 'POST',
    data: values,
  });
}
//新增
export function add(values) {
  return request('/activity/event/add', {
    method: 'POST',
    data: values,
  });
}
//更新
export function update(values) {
  return request('/activity/event/update', {
    method: 'POST',
    data: values,
  });
}
